import WrAddCommentIconComponent from './components/icons/add-comment.js';
import WrAiGeneratedIconComponent from './components/icons/ai-generated.js';
import WrArrowDownIconComponent from './components/icons/arrow-down.js';
import WrArrowLeftIconComponent from './components/icons/arrow-left.js';
import WrArrowRightIconComponent from './components/icons/arrow-right.js';
import WrOpenIconComponent from './components/icons/arrow-square-out.js';
import WrArrowUpIconComponent from './components/icons/arrow-up.js';
import WrAttachmentIconComponent from './components/icons/attachment.js';
import WrAudioIconComponent from './components/icons/audio.js';
import WrBellIconComponent from './components/icons/bell.js';
import WrBioIconComponent from './components/icons/bio.js';
import WrCalendarIconComponent from './components/icons/calendar.js';
import WrChatIconComponent from './components/icons/chat.js';
import WrCloseIconComponent from './components/icons/close.js';
import WrCrIconComponent from './components/icons/cr.js';
import WrDevicesIconComponent from './components/icons/devices.js';
import WrDoctorIconComponent from './components/icons/doctor.js';
import WrDocumentPlusIconComponent from './components/icons/document-plus.js';
import WrDoubleArrowDownIconComponent from './components/icons/double-arrow-down.js';
import WrDoubleArrowLeftIconComponent from './components/icons/double-arrow-left.js';
import WrDoubleArrowRightIconComponent from './components/icons/double-arrow-right.js';
import WrDoubleArrowUpIconComponent from './components/icons/double-arrow-up.js';
import WrDownloadIconComponent from './components/icons/download.js';
import WrEllipsisIconComponent from './components/icons/ellipsis.js';
import WrChatIconComponent$1 from './components/icons/email.js';
import WrEmptyFileIconComponent from './components/icons/empty-file.js';
import WrExclamationIconComponent from './components/icons/exclamation.js';
import WrFileIconComponent from './components/icons/file.js';
import WrFilterIconComponent from './components/icons/filter.js';
import WrGearIconComponent from './components/icons/gear.js';
import WrHamburgerIconComponent from './components/icons/hamburger.js';
import WrHeartIconComponent from './components/icons/heart.js';
import WrHistoryIconComponent from './components/icons/history.js';
import WrIndicatiorIconComponent from './components/icons/indicator.js';
import WrLightBulbIconComponent from './components/icons/light-bulb.js';
import WrLockedIconComponent from './components/icons/locked.js';
import WrMedicalChartIconComponent from './components/icons/medical-chart.js';
import WrMoonIconComponent from './components/icons/moon.js';
import WrPatientIconComponent from './components/icons/patient.js';
import WrPenIconComponent from './components/icons/pen.js';
import WrPharmacyIconComponent from './components/icons/pharmacy.js';
import WrPillIconComponent from './components/icons/pill.js';
import WrPipeIconComponent from './components/icons/pipe.js';
import WrPlusIconComponent from './components/icons/plus.js';
import WrReadCommentIconComponent from './components/icons/read-comment.js';
import WrRefreshIconComponent from './components/icons/refresh.js';
import WrScalesIconComponent from './components/icons/scales.js';
import WrScanIconComponent from './components/icons/scan.js';
import WrSearchIconComponent from './components/icons/search.js';
import WrSemeiaIconComponent from './components/icons/semeia.js';
import WrSettingsIconComponent from './components/icons/settings.js';
import WrShuffleIconComponent from './components/icons/shuffle.js';
import WrSorttIconComponent from './components/icons/sort.js';
import WrStetoscopeIconComponent from './components/icons/stetoscope.js';
import WrSunIconComponent from './components/icons/sun.js';
import WrSurveyIconComponent from './components/icons/survey.js';
import WrThickArrowDownIconComponent from './components/icons/thick-arrow-down.js';
import WrThickArrowLeftIconComponent from './components/icons/thick-arrow-left.js';
import WrThickArrowRightIconComponent from './components/icons/thick-arrow-right.js';
import WrThickArrowUpIconComponent from './components/icons/thick-arrow-up.js';
import WrTickIconComponent from './components/icons/tick.js';
import WrTimeZoneIconComponent from './components/icons/time-zone.js';
import WrTrashIconComponent from './components/icons/trash.js';
import WrUnlockedIconComponent from './components/icons/unlocked.js';
import WrVideoIconComponent from './components/icons/video.js';
import WrVitaleIconComponent from './components/icons/vitale.js';
import WrWifiIconComponent from './components/icons/wifi.js';
import WrZapArrowDownIconComponent from './components/icons/zap-arrow-down.js';
import WrZapArrowUpIconComponent from './components/icons/zap-arrow-up.js';

var Icons = /*#__PURE__*/Object.freeze({
	__proto__: null,
	AddComment: WrAddCommentIconComponent,
	AiGenerated: WrAiGeneratedIconComponent,
	ArrowDown: WrArrowDownIconComponent,
	ArrowLeft: WrArrowLeftIconComponent,
	ArrowRight: WrArrowRightIconComponent,
	ArrowSquareOut: WrOpenIconComponent,
	ArrowUp: WrArrowUpIconComponent,
	Attachment: WrAttachmentIconComponent,
	Audio: WrAudioIconComponent,
	Bell: WrBellIconComponent,
	Bio: WrBioIconComponent,
	Calendar: WrCalendarIconComponent,
	Chat: WrChatIconComponent,
	Close: WrCloseIconComponent,
	Cr: WrCrIconComponent,
	Devices: WrDevicesIconComponent,
	Doctor: WrDoctorIconComponent,
	DocumentPlus: WrDocumentPlusIconComponent,
	DoubleArrowDown: WrDoubleArrowDownIconComponent,
	DoubleArrowLeft: WrDoubleArrowLeftIconComponent,
	DoubleArrowRight: WrDoubleArrowRightIconComponent,
	DoubleArrowUp: WrDoubleArrowUpIconComponent,
	Download: WrDownloadIconComponent,
	Ellipsis: WrEllipsisIconComponent,
	Email: WrChatIconComponent$1,
	EmptyFile: WrEmptyFileIconComponent,
	Exclamation: WrExclamationIconComponent,
	File: WrFileIconComponent,
	Filter: WrFilterIconComponent,
	Gear: WrGearIconComponent,
	Hamburger: WrHamburgerIconComponent,
	Heart: WrHeartIconComponent,
	History: WrHistoryIconComponent,
	Indicator: WrIndicatiorIconComponent,
	LightBulb: WrLightBulbIconComponent,
	Locked: WrLockedIconComponent,
	MedicalChart: WrMedicalChartIconComponent,
	Moon: WrMoonIconComponent,
	Patient: WrPatientIconComponent,
	Pen: WrPenIconComponent,
	Pharmacy: WrPharmacyIconComponent,
	Pill: WrPillIconComponent,
	Pipe: WrPipeIconComponent,
	Plus: WrPlusIconComponent,
	ReadComment: WrReadCommentIconComponent,
	Refresh: WrRefreshIconComponent,
	Scales: WrScalesIconComponent,
	Scan: WrScanIconComponent,
	Search: WrSearchIconComponent,
	Semeia: WrSemeiaIconComponent,
	Settings: WrSettingsIconComponent,
	Shuffle: WrShuffleIconComponent,
	Sort: WrSorttIconComponent,
	Stetoscope: WrStetoscopeIconComponent,
	Sun: WrSunIconComponent,
	Survey: WrSurveyIconComponent,
	ThickArrowDown: WrThickArrowDownIconComponent,
	ThickArrowLeft: WrThickArrowLeftIconComponent,
	ThickArrowRight: WrThickArrowRightIconComponent,
	ThickArrowUp: WrThickArrowUpIconComponent,
	Tick: WrTickIconComponent,
	TimeZone: WrTimeZoneIconComponent,
	Trash: WrTrashIconComponent,
	Unlocked: WrUnlockedIconComponent,
	Video: WrVideoIconComponent,
	Vitale: WrVitaleIconComponent,
	Wifi: WrWifiIconComponent,
	ZapArrowDown: WrZapArrowDownIconComponent,
	ZapArrowUp: WrZapArrowUpIconComponent
});

export { Icons as I };
//# sourceMappingURL=icons-fu97oyYi.js.map
